import React from 'react';
import {useRouter} from 'next/router';

import LessonPage from '../../../../js/pages/LessonPage';

const CourseLessonPage = () => {
  const router = useRouter();
  const {
    courseOrTrack: course,
    courseOrLesson: lesson,
  } = router.query;

  return <LessonPage courseSlug={course} lessonSlug={lesson} />;
};

CourseLessonPage.getLayout = (page) => page;

export default CourseLessonPage;
